// extracted by mini-css-extract-plugin
export default {"userDetailsActionButtons":"UserDetailsActionButtons_userDetailsActionButtons__Ih9bF"};